import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { NavigationEnd, NavigationStart } from "@angular/router";
import { fromEvent } from "rxjs";
import NoSleep from 'nosleep.js';
import { COUNTRIES_LANG } from "./config/countries-lang.config";
var AppComponent = /** @class */ (function () {
    // noSleep = new NoSleepApp();
    function AppComponent(router, authenticationService, languageService, countryService, walletService, phoneVerifyService, contentDisplayingService, popupComponent, appVersionService, loginService) {
        var _this = this;
        this.router = router;
        this.authenticationService = authenticationService;
        this.languageService = languageService;
        this.countryService = countryService;
        this.walletService = walletService;
        this.phoneVerifyService = phoneVerifyService;
        this.contentDisplayingService = contentDisplayingService;
        this.popupComponent = popupComponent;
        this.appVersionService = appVersionService;
        this.loginService = loginService;
        this.login = false;
        this.isConnected = true;
        this.noInternetConnection = false;
        this.canListen = false;
        // Detects if device is in standalone mode
        this.isInStandaloneMode = function () { return ('standalone' in window.navigator) && (window.navigator['standalone']); };
        fromEvent(window, 'online').subscribe(function (resp) {
            _this.isConnected = true;
            _this.noInternetConnection = false;
            _this.popupComponent.closePopup();
        });
        fromEvent(window, 'offline').subscribe(function (resp) {
            _this.isConnected = false;
            _this.noInternetConnection = true;
            var text = _this.languageService.getString('messagesData', 'noInternetConnection');
            _this.popupComponent.showPopupError({ text: text, closeBtn: false });
        });
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationStart) {
                //console.log('Navigation Start')
                _this.canListen = false;
            }
            if (event instanceof NavigationEnd) {
                //console.log('Navigation End')
                var snakeBtns = document.querySelectorAll('.snake-btn');
                snakeBtns.forEach(function (el) {
                    el.classList.add('is-notouched');
                });
                if (document.querySelector('.login__inner')) {
                    document.querySelector('.login__inner').scrollTop = 0;
                }
                if (document.querySelector('.login__content')) {
                    document.querySelector('.login__content').scrollTop = 0;
                }
                // window.scrollTo(0,0);
                setTimeout(function () {
                    _this.canListen = true;
                }, 0);
                _this.appHeight();
            }
        });
        this.walletService.showModal.subscribe(function (val) {
            if (val.show) {
                var code = val.code;
                _this.walletService.showGeneratePopup(_this.popupGenerateContainer, code);
            }
        });
        this.phoneVerifyService.showModal.subscribe(function (val) {
            if (val.show) {
                _this.phoneVerifyService.showGeneratePopup(_this.popupGenerateContainer);
            }
        });
        this.languageService.requestNewLanguage.subscribe(function (val) {
            if (val) {
                _this.changeLanguage(val);
            }
        });
    }
    AppComponent.prototype.clickInside = function (event) {
        if (this.canListen) {
            var snakeBtns = document.querySelectorAll('.is-notouched');
            snakeBtns.forEach(function (el) {
                el.classList.remove('is-notouched');
            });
        }
        ;
    };
    AppComponent.prototype.ngOnInit = function () {
        // this.loginService.loginChanged.subscribe((value: any) => this.loginChanged(value));
        if (this.isIos()) {
            document.body.classList.add('is-ios');
        }
        window.addEventListener('resize', this.appHeight);
        window.addEventListener('orientationchange', this.appHeight);
        this.appHeight();
        this.refreshToken();
        this.appVersion();
        this.setNoScreenLock();
        this.detectLanguage();
    };
    AppComponent.prototype.detectLanguage = function () {
        var country = this.countryService.detectCountry();
        var defaultLang = '';
        var countryLang = '';
        Object.keys(COUNTRIES_LANG).forEach(function (lang) {
            COUNTRIES_LANG[lang].forEach(function (contr) {
                if (contr === 'default') {
                    defaultLang = lang;
                }
                if (contr === country) {
                    countryLang = lang;
                }
            });
        });
        var lang = countryLang ? countryLang : defaultLang;
        localStorage.setItem('country', country);
        this.changeLanguage(lang);
    };
    AppComponent.prototype.changeLanguage = function (lang) {
        this.languageService.setActiveLanguage(lang);
        localStorage.setItem('activeLanguage', lang);
    };
    AppComponent.prototype.ngOnDestroy = function () { };
    AppComponent.prototype.loginChanged = function (status) {
        this.login = status;
    };
    AppComponent.prototype.appVersion = function () {
        this.appVersionService.checkVersion();
    };
    AppComponent.prototype.refreshToken = function () {
        this.authenticationService.refreshToken();
    };
    AppComponent.prototype.isIos = function () {
        var userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    };
    AppComponent.prototype.appHeight = function () {
        setTimeout(function () {
            var doc = document.documentElement;
            doc.style.setProperty('--app-height', window.innerHeight + "px");
            doc.style.setProperty('--app-width', window.innerWidth + "px");
        }, 0);
    };
    AppComponent.prototype.setNoScreenLock = function () {
        var _this = this;
        if ('wakeLock' in navigator) {
            this.isSupportedSleep = true;
        }
        if (this.isSupportedSleep) {
            // create a reference for the wake lock
            var wakeLock_1 = null;
            // create an async function to request a wake lock
            var requestWakeLock_1 = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var err_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, navigator.wakeLock.request('screen')];
                        case 1:
                            wakeLock_1 = _a.sent();
                            // listen for our release event
                            wakeLock_1.onrelease = function (ev) {
                                //console.log(ev);
                            };
                            wakeLock_1.addEventListener('release', function () {
                                // if wake lock is released alter the button accordingly
                                //changeUI('released');
                            });
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }; // requestWakeLock()
            document.addEventListener('click', function enableNoSleep() {
                document.removeEventListener('click', enableNoSleep, false);
                requestWakeLock_1();
            }, false);
        }
        else {
            this.noSleep = new NoSleep();
            var $this_1 = this;
            document.addEventListener('click', function enableNoSleep() {
                document.removeEventListener('click', enableNoSleep, false);
                $this_1.noSleep.enable().then($this_1.updateSwitchStatus.bind($this_1));
            }, false);
        }
    };
    AppComponent.prototype.updateSwitchStatus = function () {
        var enabled = this.noSleep.isEnabled;
        if (this.noSleep._wakeLock) {
            enabled = !this.noSleep._wakeLock.released;
        }
        if (enabled) {
            console.log("noSleep is enabled");
        }
        else {
            console.log("noSleep is disabled");
        }
    };
    AppComponent.prototype.setCorrectThumbnailIcon = function () {
        if (!this.contentDisplayingService.showAdditionContent()) {
            this.changeThumbnailIcons('ratechapp');
            // if (this.contentDisplayingService.raTechappSenetReplacementText()) {
            //     document.querySelector('title').innerHTML = this.contentDisplayingService.raTechappSenetReplacementText();
            // }
        }
    };
    AppComponent.prototype.changeThumbnailIcon = function (selector, icon, domain) {
        var defaultIcon = document.querySelector(selector).getAttribute('href');
        var newIcon = defaultIcon.split('/icons')[0] + ("/domains/" + domain + "/icons/" + icon);
        document.querySelector(selector).setAttribute('href', newIcon);
    };
    AppComponent.prototype.changeThumbnailIcons = function (domain) {
        this.changeThumbnailIcon('link[rel="icon"]', 'icon-72.png', domain);
        this.changeThumbnailIcon('link[rel="apple-touch-icon"][sizes="180x180"]', 'icon-180.png', domain);
        this.changeThumbnailIcon('link[rel="apple-touch-icon"][sizes="120x120"]', 'icon-120.png', domain);
    };
    return AppComponent;
}());
export { AppComponent };
